import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlp6TipsC = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17237" data-mp="1nyfdkg2jxnmz">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17238" data-mp="1e0r8aw7bkxqk"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17239" data-mp="1e2vifvvtasza">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17240" data-mp="108bdgioko60q">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17241" data-mp="151e86u535lii">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17242" data-mp="q9dh4tkwn876">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17243" data-mp="hba4ynvt7ns1">
          <div className="text-left" data-id="element-17244" data-mp="mbo6dn2wnzh3">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17245" data-mp="3u5brxenuj0vh">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17246" data-mp="3bgersu5rpe5c">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17247" data-mp="3l683dv5wtt9l">
        <div className="max-w-4xl mx-auto" data-id="element-17248" data-mp="3gf89yzw01tbu">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17249" data-mp="3gegbnhb0phhv">
            PERSONAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-17250" data-mp="2nquccl8toz0t">
            The 6 Things Every GLP-1 User Needs to Know
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17251" data-mp="rllg8lfzpfpg">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17252" data-mp="wkodhjpqahmv">
              <img src="https://cdn.magicpatterns.com/uploads/qo1VVrn8u2FTESbwCETPV1/1.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17253" data-mp="11fbznbx9ezya" />
            </div>
            <div className="flex-1" data-id="element-17254" data-mp="8q4sxpnnj41y">
              <div className="flex items-center" data-id="element-17255" data-mp="8qwm6tts0pp2">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17256" data-mp="dog361huzgkp">
                  By Patricia Morrison, RN, CN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17257" data-mp="hrco3yuvfort">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17258" data-mp="mpwf4dobnqr1" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17259" data-mp="1t4x05obt6oiu">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17260" data-mp="1y2p2zddzrv1t">
                Chicago, IL • Former Medical Practitioner • 58 Years Old • 4
                Years on GLP-1 Medications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17261" data-mp="2382bugrxkvv0">
                <div className="flex items-center mr-4" data-id="element-17262" data-mp="1yhdl53o2s2wx">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17263" data-mp="1yfsptbtxsfy0" />
                  <span data-id="element-17264" data-mp="1ugjy0cigis53">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17265" data-mp="1ue7h82ofqntm">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17266" data-mp="1phyti0w69mau" />
                  <span data-id="element-17267" data-mp="1khud0av9krkm">42,372 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17268" data-mp="1kjxeps5s4956">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17269" data-mp="1fj9mx49q7o9w" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17270" data-mp="1bjir2m5cehyi">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-17271" data-mp="35vyqp43muxue">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-17272" data-mp="3cyn68ddmk1lv" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-17273" data-mp="3hvdv9q7eq7jf">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-17274" data-mp="37zajrtqo0wjt">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-17275" data-mp="2u745yeazj1nj">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-17276" data-mp="2kahl3pinsali">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-17277" data-mp="2p9kt9itxqwxp">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-17278" data-mp="2bbe20ljhrv70">
              "What a Chicago nurse discovered after three years of crushing
              depression on semaglutide:
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17279" data-mp="1rnhvwnyu2ovj">
              6 science-backed strategies that address nausea, hair loss,
              fatigue, and the devastating 'flat feeling' without stopping your
              medication....
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17280" data-mp="2fl72foe8so7y">
              — now helping 120+ GLP-1 users monthly at her weight loss clinic."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17281" data-mp="2paqo11tcaw6i">
            <div className="mb-1 flex items-center" data-id="element-17282" data-mp="2kbdr1o8r88q7">
              <span className="font-medium mr-2" data-id="element-17283" data-mp="2ke08cflg62lm">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17284" data-mp="2tcvfpv089iqi">
              <span className="font-medium mr-2" data-id="element-17285" data-mp="2teevlkhz1rrr">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlp6TipsC;